import Router from './config/Router/Router';
import StoreProvider from './config/StoreProvider/StoreProvider';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { GoogleOAuthProvider } from '@react-oauth/google';

const App = () => {
  return (
    <GoogleOAuthProvider clientId="720348113319-hk2dcts2mmksv03qdq3e2f8sol66jj01.apps.googleusercontent.com">
      <StoreProvider>
        <Router />
        <ToastContainer />
      </StoreProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
